import { render, staticRenderFns } from "./SwitchAssociationStatus.vue?vue&type=template&id=1ce50a9a&"
import script from "./SwitchAssociationStatus.vue?vue&type=script&lang=js&"
export * from "./SwitchAssociationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports